import { DEFAULT_SCREEN_DIMENSIONS } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/constants';
import { ScreenDimensions } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditor/types';

interface LimitValueBetweenRangeProps {
  value: number;
  min: number;
  max: number | undefined;
}

const clampValueBetweenRange = ({ value, min, max }: LimitValueBetweenRangeProps) => {
  return Math.max(min, max ? Math.min(value, max) : value);
};

export const screenDimensionsExceedMaxScreenDimensions = (
  screenDimensions: ScreenDimensions,
  maxScreenDimensions: ScreenDimensions,
) => {
  return (
    screenDimensions.width > maxScreenDimensions.width ||
    screenDimensions.height > maxScreenDimensions.height
  );
};

export const scaleScreenDimensionsByFactor = (
  screenDimensions: ScreenDimensions,
  factor: number,
) => {
  return {
    width: Math.round(screenDimensions.width * factor),
    height: Math.round(screenDimensions.height * factor),
  };
};

export const clampScreenDimensions = (
  screenDimensions: ScreenDimensions,
  maxScreenDimensions?: ScreenDimensions,
): ScreenDimensions => {
  return {
    width: clampValueBetweenRange({
      value: screenDimensions.width,
      min: DEFAULT_SCREEN_DIMENSIONS.width,
      max: maxScreenDimensions?.width,
    }),
    height: clampValueBetweenRange({
      value: screenDimensions.height,
      min: DEFAULT_SCREEN_DIMENSIONS.height,
      max: maxScreenDimensions?.height,
    }),
  };
};
